module.exports = __webpack_public_path__ + "img/ebook-readmoo.d417c36c.png";